export default "__VITE_ASSET__90884ec4__"